import { useEffect, useMemo, useRef, type ReactNode } from "react";
import {
  deviceLayout,
  trackToolExperience,
  type ToolExperienceEvent,
} from "../../features/toolExperience/telemetry";
import type { ToolId } from "../../features/toolExperience/types";
import styles from "./ToolPage.module.css";
import { ToolEvents } from "./ToolEvents";
export function ToolPage({
  children,
  toolId,
}: {
  children: ReactNode;
  toolId?: ToolId;
}) {
  const started = useRef(Date.now());
  const viewed = useRef<ToolId | undefined>(undefined);
  const track = useMemo(
    () => (event: ToolExperienceEvent) => {
      if (!toolId) return;
      const screens =
        window.scrollY /
        Math.max(1, window.visualViewport?.height || window.innerHeight);
      trackToolExperience(event, {
        toolId,
        source: "page",
        layout: deviceLayout(),
        elapsedMs: Date.now() - started.current,
        scrollBucket:
          screens < 0.25
            ? "none"
            : screens <= 1
              ? "one-screen"
              : "multiple-screens",
      });
    },
    [toolId],
  );
  useEffect(() => {
    if (toolId && viewed.current !== toolId) {
      viewed.current = toolId;
      track("tool_viewed");
    }
  }, [toolId, track]);
  return (
    <ToolEvents.Provider value={track}>
      <div className={styles.page}>{children}</div>
    </ToolEvents.Provider>
  );
}
